import ActiveRecord from './active_record/base'

class UserWeek extends ActiveRecord {
	static tableName = 'userWeeks'
}

export default UserWeek
